MessageFormat.locale.de = function(a) {
    return 1 === a ? "one" : "other"
}, MessageFormat.locale.en = function(a) {
    return 1 === a ? "one" : "other"
}, MessageFormat.locale.es = function(a) {
    return 1 === a ? "one" : "other"
}, MessageFormat.locale.fr = function(a) {
    return 0 === a || 1 == a ? "one" : "other"
}, MessageFormat.locale.ja = function() {
    return "other"
}, MessageFormat.locale.ko = function() {
    return "other"
}, MessageFormat.locale.pt = function(a) {
    return 1 === a ? "one" : "other"
}, MessageFormat.locale.zh = function() {
    return "other"
};
